export const GETBEAMER_SEGMENT_TYPE = {
  ANONYMOUS: 'anonymous',
  PLUS: 'plus',
  NON_PLUS: 'non plus',
};

export const ACTIVITY_TYPE = {
  DEAL_PURCHASE: 'deal_purchase',
  DEAL_SEARCH: 'deal_search',
  DEAL_VIEW: 'deal_view',
};

// Match backend enum https://github.com/appsumo/appsumo-2/blob/master/appsumo/deals/constants.py#L88
export const DEAL_LISTING_TYPE = {
  ORIGINAL: 'original',
  SELECT: 'select',
  INFO: 'info',
  MARKETPLACE: 'marketplace',
  FREEBIE: 'freebie',
  PLUS_EXCLUSIVE: 'plus_exclusive',
};

export const PLACEHOLDER_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8+R8AAvcB+vBGZskAAAAASUVORK5CYII=';
// export const DEAL_PLACEHOLDER_IMG = 'https://appsumo2-ci3.b-cdn.net/static/images/home/as-taco-16:9.png';
// 3:2 transparent image
export const DEAL_PLACEHOLDER_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAADklEQVR42mNkAANGCAUAACMAA2w/AMgAAAAASUVORK5CYII=';

const currentYear = new Date().getFullYear();
export const SUMO_DAY_SLUG = `sumo-day-${currentYear}`;
export const SUMO_DAY_PARTICIPATION_SLUG = `sumo_days_${currentYear}`;
export const SUMO_DAY_BANNER_TEXT = 'sumo day badge'; // match text from DealSerializer --> banner_details_object()
export const BLACK_FRIDAY_BANNER_TEXT = 'black friday badge'; // match text from DealSerializer --> banner_details_object()
export const COMING_SOON_BANNER_TEXT = 'Coming soon!'; // match text from DealSerializer --> banner_details_object()
export const BLACK_FRIDAY_SLUG = `black-friday-${currentYear}`;
export const BLACK_FRIDAY_PARTICIPATION_SLUG = `black_friday_${currentYear}`;
export const BLACK_FRIDAY_LAST_CALL_SLUG = `black-friday-last-call-${currentYear}`;
export const BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG = `black_friday_last_call_${currentYear}`;
export const LAST_CALL_SLUG = 'last-call';
export const LAST_CALL_PARTICIPATION_SLUG = 'last_call';

export const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i;

// Same regex validation we have in the backend
export const URL_REGEX = /^((?:https?:\/\/)?[^./ ]+(?:\.[^./ ]+)+(?:\/.*)?)$/i;
// Note, we are leaving this as is (ignoring SonarQube) due to issues we ran
// into testing in CI during maintenance week. There are cookie collision issues
// that cause users to be unable to log in with Chrome if they have previously logged
// into that host/site
export const SESSION_COOKIE_NAME = (process.env.VUE_APP_ENV_NAME // eslint-disable-line no-nested-ternary, max-len
  ? (process.env.VUE_APP_ENV_NAME === 'prod' ? 'sid' : `${process.env.VUE_APP_ENV_NAME}_sid`)
  : (process.env.NODE_ENV === 'production' ? 'sid' : 'dev_sid')
);

export const PDP_REGEX = /\/products\/[a-zA-Z0-9_-]+\/$/;

export const IS_INDEXABLE_PAGE_REGEX = /\/products\/[a-zA-Z0-9_-]+\/(reviews|questions)\/[a-zA-Z0-9_-]+\/$/;

// jl: we're setting this to match 'NUXT_COMMENTS_QUESTION_PAGE_SIZE' and
// 'NUXT_COMMENTS_REVIEW_PAGE_SIZE' from config --> base.py
export const MAX_COMMENT_PAGE_SIZE = 5;

// Centralize all dynamic smart collection types
export const DYNAMIC_SMART_COLLECTION_TYPE = {
  WISHLISTS: 'Wishlists',
};

export const PDP_BREADCRUMB_SLUGS = ['group', 'category', 'subcategory'];

export const BLACKLIST_ATTRIBUTE = [
  ...PDP_BREADCRUMB_SLUGS,
  'product_type',
  'product_tag',
  'os',
];

export const ATTRIBUTE_TYPE = {
  BOOLEAN: 'boolean',
};

export const ATTRIBUTE_ICON = {
  product_tag: 'tag',
  best_for: 'star',
  alternative_to: 'exchange-alt',
  integrations: 'laptop-code',
  os: 'globe',
  features: 'list',
  certification: 'award',
  resource_type: 'cogs',
  existing_accounts: 'check',
};

export const GTM_PAGEVIEW_EVENT_NAME = 'nuxtRoute';

// Social media share URLs
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?';
export const LINKEDIN_SHARE_URL = 'https://www.linkedin.com/shareArticle?mini=true&';

export const CAMPAIGN_BUTTON_TIMER = 96 * 3600e3;

export const OVERLAY_OVER_NAVBAR_CLASS = 'overflow-over-navigation';
export const SC_ZONE_EXPERIMENT_NAME = 'use-smartcollection-zones';
export const ANONYMOUS_BROWSE_EXPERIMENT_NAME = 'use-anonymous-browse';
export const CART_LOGIN_REDIRECT_EXPERIMENT_NAME = 'cart-login-redirect';
export const MOBILE_STICKY_COUNTDOWN_TIMER_EXPERIMENT_NAME = 'mobile-sticky-timer';
export const DESKTOP_STICKY_COUNTDOWN_TIMER_EXPERIMENT_NAME = 'desktop-sticky-timer';
export const DESKTOP_STICKY_BUY_EXPERIMENT_NAME = 'desktop-sticky-buy';
export const HOME_CALLOUT_COPY_EXPERIMENT_NAME = 'home-callout-copy';
export const PDP_ASKSUMO_EXPERIMENT_NAME = 'pdp-asksumo';
export const PDP_DESKTOP_TIMER_EXPERIMENT_NAME = 'pdp-desktop-timer';
export const PDP_SAVE_BADGE_EXPERIMENT_NAME = 'pdp-save-badge';
export const HIDE_STICKY_TABS_EXPERIMENT_NAME = 'hide-sticky-tabs';
export const DEFAULT_HIGHER_TIER_EXPERIMENT_NAME = 'default-higher-tier';
export const ASKUMO_CLEANUP_EXPERIMENT_NAME = 'asksumo-v2';
export const PROJECT_FOMO_EXPERIMENT_NAME = 'nav-project-fomo-v2';
export const SWAG_PROMO_EXPERIMENT_NAME = 'swag-promo';
export const NAV_FREE_DEALS_EXPERIMENT_NAME = 'nav-free-deals';
export const NAV_SIGN_UP_EXPERIMENT_NAME = 'nav-sign-up';

export const SWAG_PROMO_CAMPAIGN_NAME = 'sd-swag-promo-2023';

export const WAITLIST_URL = '/deal/waitlist-signup/';
export const SUBSCRIBE_URL = '/accounts/signup/email-subscribe/';

export const USE_NEXT_PDP_EXPERIMENT_NAME = 'next-pdp';
export const USE_NEXT_QUESTION_REVIEW_EXPERIMENT_NAME = 'next-qnr';

export default {
  CAMPAIGN_BUTTON_TIMER,
  GETBEAMER_SEGMENT_TYPE,
  PLACEHOLDER_IMG,
  DEAL_PLACEHOLDER_IMG,
  SUMO_DAY_SLUG,
  BLACK_FRIDAY_SLUG,
  SUMO_DAY_PARTICIPATION_SLUG,
  BLACK_FRIDAY_PARTICIPATION_SLUG,
  BLACK_FRIDAY_LAST_CALL_SLUG,
  BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
  SESSION_COOKIE_NAME,
  LAST_CALL_SLUG,
  LAST_CALL_PARTICIPATION_SLUG,
  MAX_COMMENT_PAGE_SIZE,
  DYNAMIC_SMART_COLLECTION_TYPE,
  PDP_BREADCRUMB_SLUGS,
  BLACKLIST_ATTRIBUTE,
  ATTRIBUTE_TYPE,
  ATTRIBUTE_ICON,
  FACEBOOK_SHARE_URL,
  TWITTER_SHARE_URL,
  LINKEDIN_SHARE_URL,
  OVERLAY_OVER_NAVBAR_CLASS,
  DEAL_LISTING_TYPE,
  SC_ZONE_EXPERIMENT_NAME,
  ANONYMOUS_BROWSE_EXPERIMENT_NAME,
  CART_LOGIN_REDIRECT_EXPERIMENT_NAME,
  WAITLIST_URL,
  SUBSCRIBE_URL,
  MOBILE_STICKY_COUNTDOWN_TIMER_EXPERIMENT_NAME,
  DESKTOP_STICKY_COUNTDOWN_TIMER_EXPERIMENT_NAME,
  DESKTOP_STICKY_BUY_EXPERIMENT_NAME,
  HOME_CALLOUT_COPY_EXPERIMENT_NAME,
  PDP_ASKSUMO_EXPERIMENT_NAME,
  PDP_DESKTOP_TIMER_EXPERIMENT_NAME,
  PDP_SAVE_BADGE_EXPERIMENT_NAME,
  HIDE_STICKY_TABS_EXPERIMENT_NAME,
  DEFAULT_HIGHER_TIER_EXPERIMENT_NAME,
  PROJECT_FOMO_EXPERIMENT_NAME,
  SWAG_PROMO_EXPERIMENT_NAME,
  SWAG_PROMO_CAMPAIGN_NAME,
  NAV_FREE_DEALS_EXPERIMENT_NAME,
  NAV_SIGN_UP_EXPERIMENT_NAME,
};
